module.exports = __webpack_public_path__ + "static/media/hd-buttercup-small_2x.1ef0097d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/hd-buttercup-small_2x.png
// module id = 826
// module chunks = 27